<template>
    <v-container v-if="superUser || permission" fluid>
        <v-sheet class="pa-3">

            <v-item-group v-model="selectedProduct">
                <v-container>
                    <v-row class="row d-flex justify-center align-center">
                        <v-col
                            v-for="n in products"
                            :key="n.subscription_product_id"
                            cols="12"
                            lg="4"
                            xl="3"
                            md="6"
                        >
                            <v-item v-slot="{ active, toggle }" :value="n">
                                <v-card
                                    :color="active ? 'primary' : ''"
                                    class=" pa-3 "
                                    @click="toggle"
                                >
                                    <v-img
                                        max-width="100%"
                                        max-height="300"
                                        :src="
                                            n.image_url ||
                                                '/images/productDefault.png'
                                        "
                                    ></v-img>
                                    <v-scroll-y-transition>
                                        <div
                                            class="text-h6 flex-grow-1 text-center pb-3 pt-3"
                                        >
                                            {{ n.name[lang] }}
                                        </div>
                                    </v-scroll-y-transition>
                                    <v-divider />
                                    <div
                                        class="text-body-2 flex-grow-1 text-center pb-3  pt-3"
                                    >
                                        {{ n.description[lang] }}
                                    </div>
                                </v-card>
                            </v-item>
                        </v-col>
                    </v-row>
                </v-container>
            </v-item-group>
            <v-dialog
                v-model="detailsDialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <b-card
                    class="fixed-actions"
                    v-if="selectedProduct"
                    :title="selectedProduct.name[lang]"
                    :submit-text="translations.purchase"
                    :disabled="!selectedVariantId"
                    :loading="loading"
                    @cancel="closeDetailsDialog"
                    @submit="openConfirmationDialog"
                >

                    <v-row cols="12" md="12" class="full-height">
                        <v-col
                            cols="12"
                            md="6"
                            sm="12"
                            class="d-flex flex-column align- justify-flex-start"
                        >
                            <v-img
                                max-width="100%"
                                max-height="300"
                                :src="
                                    selectedProduct.image_url ||
                                        ''
                                "
                            ></v-img>

                            <div
                                class="text-body-1 text-center pb-6  pt-3"
                            >
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th
                                                    class="text-left"
                                                    style="height: 10px;"
                                                ></th>
                                                <th
                                                    class="text-left"
                                                    style="height: 10px;"
                                                ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr></tr>
                                            <tr>
                                                <td>{{ translations.productType[lang] }}</td>
                                                <td>
                                                    {{
                                                        selectedProduct
                                                            .subscription_product_type
                                                            .name[lang]
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                            <div class="text-body-1 text-center pb-3  pt-3">
                                {{ selectedProduct.description[lang] }}
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card flat >
                                <div v-if="selectableAttributes.length">
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    v-for="attribute in selectableAttributes"
                                    :key="attribute.attribute_id"
                                >
                                  <span class="text-subtitle-2 font-weight-medium pr-2"> {{ attribute.name[lang] }}: </span> 
                                    <v-btn-toggle
                                        v-model="attribute.selected_option_id"
                                        color="primary accent-3"
                                        @change="selectVariant"
                                    >
                                        <v-btn
                                            v-for="option in attribute.options"
                                            :key="option.attribute_option_id"
                                            :value="option.attribute_option_id"
                                            :disabled="
                                                !variationExists(
                                                    attribute,
                                                    option
                                                )
                                            "
                                        >
                                            {{ option.title[lang] }} 
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                            </div>
                            <div
                            v-if="
                                    selectedProduct.subscription_product_credit
                                "
                            >
                                    <span class="text-subtitle-2 font-weight-medium pr-2 pl-3"> {{ translations.availableOptions[lang] }}: </span> 

                                <v-col cols="12" md="12" sm="12">
                                    <v-btn-toggle
                                        v-model="selectedVariantId"
                                        color="primary"
                                        class="d-flex flex-wrap"
                                    >
                                        <v-btn
                                            v-for="variant in selectedProduct.subscription_product_variants"
                                            :key="
                                                variant.subscription_product_variant_id
                                            "
                                            :value="
                                                variant.subscription_product_variant_id
                                            "
                                        >
                                            {{ variant.name[lang] }}
                                        </v-btn>
                                    </v-btn-toggle>

                                </v-col>
                            </div>
                            
                            <div
                            v-if="selectedVariant"
                                        class="text-body-1 flex-grow-1 text-center pb-3  pt-3"
                                    >
                                    <v-col v-if="selectedProduct.subscription_product_credit" class="d-flex justify-center">
                                        <span class="text-h6 font-weight-medium">{{ selectedVariant.name[lang] }}</span>
                                    </v-col>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th
                                                            class="text-left"
                                                            style="height: 10px;"
                                                        ></th>
                                                        <th
                                                            class="text-left"
                                                            style="height: 10px;"
                                                        ></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr></tr>
                                                    <tr>
                                                        <td class="text-left pl-8">{{ translations.price[lang] }}</td>
                                                        <td class="text-left">
                                                            {{
                                                                selectedVariant
                                                                    .price
                                                            }} €
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left pl-8">SKU</td>
                                                        <td class="text-left" style="min-width: 50%;">
                                                            {{
                                                                selectedVariant
                                                                    .sku_number
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="selectedProduct.subscription_product_credit">
                                                        <td>
                                            <v-checkbox
                                                color="secondary"
                                                class="pa-3 pt-0"
                                                hide-details
                                                v-model="hasThreshold"
                                            >
                                                <template v-slot:label>
                                                    <h4 class="subtitle-2">{{ translations.hasThreshold[lang] }}</h4>
                                                </template>
                                            </v-checkbox>
                                                        </td>
                                                        <td >
                                                            <div v-if="hasThreshold" class="mt-n3">
                                            <b-text-field
                                                v-model="threshold"
                                                class="mt-0 pt-0"
                                                style="background: white;"
                                                :label="translations.thresholdLabel[lang]"
                                                hide-details
                                                single-line
                                                type="number"
                                            ></b-text-field>
                                        </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                            </v-card>

                        </v-col>
                    </v-row>

                </b-card>
            </v-dialog>
        </v-sheet>
        <v-dialog v-model="confirmationDialog" max-width="500">
            <b-card
                v-if="selectedProduct"
                :title="`${translations.confirmPurchaseTitle[lang]}: ${selectedProduct.name[lang]}`"
                @cancel="confirmationDialog = false"
                @submit="confirmPurchase()"
                :submit-text="translations.submit"
                :cancel-text="translations.cancel"
                :loading="loading"
            >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <v-col cols="12" md="12">
                            <v-row v-if="selectedVariant">
                                
                                <v-col cols="12" md="12" class="py-0"
                                    ><span>{{ translations.confirmPurchase1[lang] }}</span><span class="font-weight-bold pr-2"
                                        >{{ selectedVariant.name[lang] }}</span
                                    ><span>{{ translations.confirmPurchase2[lang] }}</span>
                                    <span class="font-weight-bold pr-2"> {{ selectedProduct.name[lang] }}</span></v-col
                                >
                                <v-col cols="12" md="12" class="py-0"
                                    ><span>{{ translations.confirmPurchase3[lang] }}</span><span class="font-weight-bold pr-2"
                                        >{{ selectedVariant.sku_number }}</span
                                    >
                                    </v-col
                                >
                                <v-col v-if="hasThreshold" cols="12" md="12" class="py-0"
                                    ><span>{{ translations.confirmPurchase3t[lang] }}</span><span class="font-weight-bold pr-2"
                                        >{{ threshold }}</span
                                    >
                                    </v-col
                                >
                                <v-col cols="12" md="12" class="py-0"
                                    ><span>{{ translations.confirmPurchase4[lang] }}</span><span class="font-weight-bold pr-2"
                                        >{{ selectedVariant.price }}€</span
                                    >
                                    </v-col
                                >
                            </v-row>
                        </v-col>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {
    mdiCheckCircleOutline,
    mdiMinusCircleOutline,
    mdiClose,
    mdiCheckboxMarkedOutline,
    mdiTableEye,
    mdiPencilOutline,
    mdiArrowRightBold,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiCheck,
    mdiListBox
} from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/general/settings/roadcubeMarket";
import { cloneDeep, intersection } from "lodash";

export default {
    name: "Shop",

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiCheckCircleOutline,
                mdiMinusCircleOutline,
                mdiClose,
                mdiCheckboxMarkedOutline,
                mdiTableEye,
                mdiPencilOutline,
                mdiArrowRightBold,
                mdiCheckCircle,
                mdiCloseCircle,
                mdiCheck,
                mdiListBox
            },
            detailsDialog: false,
            selectedProduct: null,
            confirmationDialog: false,
            selectedVariantId: null,
            selectedAttributes: [],
            selectableAttributes: [],
            hasThreshold: false,
            threshold: null
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "permissions",
            "storePermissions"
        ]),

        ...mapState("general/settings/roadcubeMarket/shop", ["products"]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        query() {
            let query = "?";
            for (let key in this.$route.query) {
                if (this.$route.query[key]) {
                    query += `${key}=${this.$route.query[key]}&`;
                }
            }
            return query.slice(0, query.length - 1);
        },

        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions
                    ? this.$store.state.permissions.developers?.webhooks.read
                    : null)
            );
        },

        selectedVariant() {
            return this.selectedProduct?.subscription_product_variants?.find(
                x => x.subscription_product_variant_id == this.selectedVariantId
            );
        },

        selectableCredits() {
            let creds = [];
            return creds;
        }
    },

    methods: {
        ...mapActions("general/settings/roadcubeMarket/shop", [
            "getShopProducts", "buyShopProducts"
        ]),

        variationExists(attribute, option) {
            let exists = this.selectableAttributes?.length > 0;
            this.selectableAttributes.forEach(a => {
                if (
                    a.attribute_id != attribute.attribute_id &&
                    a.selected_option_id
                ) {
                    let selectedOption = a.options.find(
                        x => x.attribute_option_id == a.selected_option_id
                    );
                    exists = selectedOption.variant_ids.some(item =>
                        option.variant_ids.includes(item)
                    );
                }
            });
            return exists;
        },
        selectVariant() {
            let variant = [];
            this.selectableAttributes.forEach(att => {
                let selectedOption = att.options.find(
                    x => x.attribute_option_id == att.selected_option_id
                );
                if (selectedOption) {
                    if (!variant.length) {
                        variant = selectedOption?.variant_ids || [];
                    } else {
                        variant = intersection(
                            variant,
                            selectedOption?.variant_ids || []
                        );
                    }
                }
                if (variant.length === 1) {
                    this.selectedVariantId = variant[0];
                } else {
                    this.selectedVariantId = null;
                }
            });
        },
        openDetailsDialog(item) {
            this.detailsDialog = true;
        },
        closeDetailsDialog() {
            this.confirmationDialog = false
            this.selectedAttributes = [];
            this.selectableAttributes = [];
            this.selectedVariantId = null;
            this.selectedProduct = null;
            this.threshold = null;
            this.hasThreshold = false;
        },

        openConfirmationDialog() {
            this.confirmationDialog = true;
        },
        transformSelectableAttributes() {
            let atts = this.selectableAttributes;
            this.selectedProduct.subscription_product_variants?.forEach(
                variant => {
                    variant.subscription_product_variant_attributes.forEach(
                        e => {
                            let att = atts.find(
                                x =>
                                    x?.attribute_id ==
                                    e.attribute_option?.attribute.attribute_id
                            );
                            let option = att?.options?.find(
                                option =>
                                    option.attribute_option_id ==
                                    e.attribute_option.attribute_option_id
                            );
                            if (!att) {
                                atts.push({
                                    attribute_id:
                                        e.attribute_option.attribute
                                            .attribute_id,
                                    name: e.attribute_option.attribute.name,
                                    options: [
                                        {
                                            attribute_option_id:
                                                e.attribute_option
                                                    .attribute_option_id,
                                            title: e.attribute_option.option,
                                            variant_ids: [
                                                variant.subscription_product_variant_id
                                            ]
                                        }
                                    ],
                                    selected_option_id: 0
                                });
                            } else if (!option) {
                                att.options.push({
                                    attribute_option_id:
                                        e.attribute_option.attribute_option_id,
                                    title: e.attribute_option.option,
                                    variant_ids: [
                                        variant.subscription_product_variant_id
                                    ]
                                });
                            } else if (
                                att &&
                                option &&
                                !option?.variant_ids?.includes(
                                    variant.subscription_product_variant_id
                                )
                            ) {
                                option.variant_ids.push(
                                    variant.subscription_product_variant_id
                                );
                            }
                        }
                    );
                }
            );

            return atts;
        },
        async confirmPurchase(){
           
            let body = {
                "subscription_product_variants": [this.selectedVariantId],
            }
            if(this.hasThreshold){
                body.threshold = this.threshold
            }
            let resData = await this.buyShopProducts(body)
            if (resData?.status	 == 'success') {
                this.confirmationDialog = false
                this.setNotification({
                    show: true,
                    type: "success",
                    text: `${this.translations.purchaseSuccess[this.lang]} ${this.selectedProduct.name[this.lang]}`
                })    
                this.closeDetailsDialog()

            }else {
                this.confirmationDialog = false
                this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.purchaseError[this.lang]
                })    
            }
        },
    },

    watch: {
        $route(val) {
            this.getShopProducts(this.query);
        },
        selectedProduct: {
            deep: true,
            handler(val) {
                this.detailsDialog = !!val;
                if (val) {
                    this.selectableAttributes = [];
                    this.transformSelectableAttributes();
                }
            }
        },
        detailsDialog: {
            handler(val) {
                if (this.selectedProduct && !val) {
                    this.selectedProduct = null;
                }
            }
        }
    },

    mounted() {
        this.getShopProducts(this.query);
    }
};
</script>

<style>
.webhooks-table th {
    padding-left: 3px !important;
    padding-right: 3px !important;
}
.webhooks-table td {
    padding-left: 3px !important;
    padding-right: 3px !important;
}

.event-chips {
    max-height: 200px;
    overflow: scroll;
}
.event-chips .v-slide-group__wrapper {
    overflow: scroll;
}
.v-card.fixed-actions .v-card__actions {
  position: fixed;
  right: 0;
  background: white;
  width: 100vw;
  bottom: 0;
  border-top: 1px solid #80808061;
}
.v-card.fixed-actions {
    padding-bottom: 53px !important;
}
.full-height {
    min-height: 100vh;
}
</style>
